// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab__Knyxe","active":"active__3QDI7","unread":"unread__bBS4k"};